import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleNavClick = (item) => {
    if (item.external) {
      window.open(item.url, '_blank');
      setIsMobileMenuOpen(false);
    } else {
      scrollToSection(item.id);
    }
  };

  const navItems = [
    { label: 'Accueil', id: 'hero' },
    { label: 'Services', id: 'services' },
    { label: 'Historique', id: 'history-values' },
    { label: 'Réalisations', id: 'projects' },
    { label: 'Agence', url: 'https://dakarappartement.sogi.sn/', external: true },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white'
      }`}
    >
      <div className="container mx-auto px-6">
        {/* Top contact bar with yellow background */}
        <div className="hidden md:flex items-center justify-between py-3 border-b-2 border-yellow-400">
          <div className="flex items-center gap-6 text-sm">
            <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 text-gray-700 hover:text-yellow-600 transition-colors font-medium">
              <Phone size={16} className="text-yellow-500" />
              {companyInfo.phone}
            </a>
            <a href={`tel:${companyInfo.phone2}`} className="flex items-center gap-2 text-gray-700 hover:text-yellow-600 transition-colors font-medium">
              <Phone size={16} className="text-yellow-500" />
              {companyInfo.phone2}
            </a>
          </div>
          <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 text-gray-700 hover:text-yellow-600 transition-colors font-medium text-sm">
            <Mail size={16} className="text-yellow-500" />
            {companyInfo.email}
          </a>
        </div>

        <div className="flex items-center justify-between py-4">
          {/* Logo - Plus grand */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/a4svjjfw_400dpiLogoCropped.png" 
              alt="SOGI Logo" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation - Plus visible */}
          <nav className="hidden md:flex items-center gap-2">
            {navItems.map((item) => (
              <button
                key={item.id || item.label}
                onClick={() => handleNavClick(item)}
                className="px-5 py-2.5 text-gray-700 hover:text-yellow-600 font-semibold transition-all rounded-lg hover:bg-yellow-50 relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-500 transition-all group-hover:w-full"></span>
              </button>
            ))}
          </nav>

          {/* CTA Button - Plus visible */}
          <Button
            onClick={() => scrollToSection('contact')}
            className="hidden md:flex bg-gradient-to-r from-yellow-500 to-yellow-400 hover:from-yellow-600 hover:to-yellow-500 text-gray-900 font-bold px-6 py-6 shadow-lg hover:shadow-xl transition-all whitespace-nowrap shrink-0"
          >
            Demander un devis
          </Button>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-gray-50 rounded-lg transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-2">
            {navItems.map((item) => (
              <button
                key={item.id || item.label}
                onClick={() => handleNavClick(item)}
                className="text-left px-4 py-3 text-gray-600 hover:text-yellow-600 hover:bg-gray-50 rounded-lg font-medium transition-colors"
              >
                {item.label}
              </button>
            ))}
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-yellow-500 hover:bg-yellow-600 text-white mt-2"
            >
              Demander un devis
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
